import { render, staticRenderFns } from "./PetugasTcTidakAktif.vue?vue&type=template&id=c789101e&"
import script from "./PetugasTcTidakAktif.vue?vue&type=script&lang=js&"
export * from "./PetugasTcTidakAktif.vue?vue&type=script&lang=js&"
import style0 from "./PetugasTcTidakAktif.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports